<template>
  <div
      :class="panel ? 'cp-bar cp-bar--alpha' : 'color-alpha'"
      @mousedown.prevent.stop="selectAlpha"
  >
    <canvas ref="canvasAlpha" />
    <div
        :style="slideAlphaStyle"
        :class="panel ? 'cp-bar__thumb' : 'slide'"
    />
  </div>
</template>

<script>
import mixin from './mixin';

const PANEL_WIDTH  = 256;
const PANEL_HEIGHT = 10;

export default {
  mixins: [mixin],
  props:  {
    color: {
      type:    String,
      default: '#000000',
    },
    rgba: {
      type:    Object,
      default: null,
    },
    width: {
      type:    Number,
      default: 15,
    },
    height: {
      type:    Number,
      default: 152,
    },
    panel: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return {
      alphaSize:      5,
      sliderPosition: 0,
    };
  },
  computed: {
    slideAlphaStyle() {
      if (this.panel) {
        return { left: `${Math.min(1, Math.max(0, this.rgba.a)) * 100}%` };
      }
      let top = Math.max(this.rgba.a * this.height, 0);
      top     = Math.min(this.height - 6, top);
      return { top: `${top}px` };
    },
  },
  watch: {
    color() {
      this.renderColor();
    },
    /* ,
    'rgba.a': function () {
      this.renderSlide();
    }, */
  },
  mounted() {
    this.renderColor();
    // this.renderSlide();
  },
  methods: {
    renderColor() {
      if (this.panel) {
        this.renderPanelColor();
        return;
      }
      const canvas       = this.$refs.canvasAlpha;
      const width        = this.width;
      const height       = this.height;
      const size         = this.alphaSize;
      const canvasSquare = this.createAlphaSquare(size);

      const ctx     = canvas.getContext('2d');
      canvas.width  = width;
      canvas.height = height;

      ctx.fillStyle = ctx.createPattern(canvasSquare, 'repeat');
      ctx.fillRect(0, 0, width, height);

      this.createLinearGradient('p', ctx, width, height, 'rgba(255,255,255,0)', this.color);
    },
    renderPanelColor() {
      const canvas       = this.$refs.canvasAlpha;
      const canvasSquare = this.createAlphaSquare(this.alphaSize);

      const ctx     = canvas.getContext('2d');
      canvas.width  = PANEL_WIDTH;
      canvas.height = PANEL_HEIGHT;

      ctx.fillStyle = ctx.createPattern(canvasSquare, 'repeat');
      ctx.fillRect(0, 0, PANEL_WIDTH, PANEL_HEIGHT);

      this.createLinearGradient('l', ctx, PANEL_WIDTH, PANEL_HEIGHT, 'rgba(255,255,255,0)', this.color);
    },
    renderSlide() {
      this.slideAlphaStyle = { top: `${this.getSliderTop}px` };
    },

    selectAlpha(e) {
      if (this.panel) {
        this.selectPanelAlpha(e);
        return;
      }
      const { top: hueTop } = this.$el.getBoundingClientRect();

      const mousemove = (e) => {
        let y = e.clientY - hueTop;

        if (y < 0) {
          y = 0;
        }
        if (y > this.height) {
          y = this.height;
        }

        const a = parseFloat((y / this.height).toFixed(2));
        this.$emit('selectAlpha', a);
      };

      mousemove(e);
      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };
      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
    selectPanelAlpha(e) {
      const rect = this.$el.getBoundingClientRect();

      const mousemove = (event) => {
        const fx = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        this.$emit('selectAlpha', parseFloat(fx.toFixed(2)));
      };

      mousemove(e);

      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
  },
};
</script>

<style lang="scss">
.color-alpha {
  position: relative;
  margin-left: 8px;
  cursor: pointer;
  .slide {
    position: absolute;
    left: -3px;
    top: 100px;
    right: -5px;
    height: 6px;
    border: solid thin #202020;
    border-radius: 5px !important;
    background: transparent;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3);
    pointer-events: none;
  }
}
</style>
